export default "__VITE_ASSET__9TtyITiD__"